export const WHATSAPP_NUMBER = "18736608112";
export const WHATSAPP_DISPLAY = "+1 873-660-8112";
export const EMAIL = "info@coachromeo.ca";
export const INTERAC_EMAIL = "coachromeo7@hotmail.com";

export const waLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MSG = {
    fr: "Bonjour Coach Roméo, je souhaite en savoir plus sur votre coaching.",
    en: "Hello Coach Roméo, I would like to know more about your coaching.",
};

export const EBOOK = {
    title: { fr: "Manger Africain, Brûler le Gras", en: "Eat African, Burn Fat" },
    subtitle: {
        fr: "Le guide complet de la perte de gras par la cuisine africaine",
        en: "The complete guide to fat loss through African cuisine",
    },
    price: "39,99 $ CAD",
    cover: "https://images.unsplash.com/photo-1665332195309-9d75071138f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    bullets: [
        { fr: "45 recettes africaines recalibrées pour la perte de gras", en: "45 African recipes recalibrated for fat loss" },
        { fr: "Plans de repas de 8 semaines, petit-déjeuner au souper", en: "8-week meal plans, from breakfast to dinner" },
        { fr: "Listes d'épicerie adaptées au Canada et à l'Afrique", en: "Grocery lists adapted to Canada and Africa" },
        { fr: "Le guide des portions : manger copieux, brûler quand même", en: "The portion guide: eat hearty, burn anyway" },
        { fr: "Bonus : 12 sauces et marinades allégées pleines de caractère", en: "Bonus: 12 light sauces and marinades full of character" },
    ],
};

export const EBOOK_BUY_MSG = {
    fr: "Bonjour Coach Roméo, je souhaite acheter votre Ebook « Manger Africain, Brûler le Gras » (39,99 $ CAD).",
    en: "Hello Coach Roméo, I would like to buy your Ebook 'Eat African, Burn Fat' (39,99 $ CAD).",
};

export const IMAGES = {
    heroCoach: "/images/coach-romeo.jpg",
    aboutCoach: "/images/coach-romeo.jpg",
    manifestoFood: "https://images.pexels.com/photos/37648018/pexels-photo-37648018.jpeg?auto=compress&cs=tinysrgb&w=1200",
    programsBg:
        "https://images.unsplash.com/photo-1584735935682-2f2b69dff9d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const PROGRAMS = [
    {
        id: "presentiel",
        name: { fr: "Muscu Présentiel", en: "In-Person Training" },
        price: "400 $",
        period: { fr: "forfait", en: "package" },
        tagline: {
            fr: "Le forfait basique — entraînement en personne avec le coach.",
            en: "The basic package — in-person training with the coach.",
        },
        features: [
            { fr: "Salle de gym à Gatineau et à Ottawa", en: "Gym locations in Gatineau and Ottawa" },
            { fr: "Séances de musculation en présentiel avec Coach Roméo", en: "In-person training sessions with Coach Roméo" },
            { fr: "Technique corrigée en direct, à chaque répétition", en: "Technique corrected live, on every rep" },
            { fr: "Motivation et intensité garanties sur place", en: "Motivation and intensity guaranteed on site" },
        ],
        popular: false,
    },
    {
        id: "enligne",
        name: { fr: "Coaching en Ligne", en: "Online Coaching" },
        price: "150 $",
        period: { fr: "", en: "" },
        tagline: {
            fr: "Application Coach Roméo — plan 100 % personnalisé.",
            en: "Coach Roméo app — 100% personalized plan.",
        },
        features: [
            { fr: "Plan 100 % personnalisé : entraînement + nutrition", en: "100% personalized plan: training + nutrition" },
            { fr: "Suivi complet dans l'application Coach Roméo", en: "Full tracking in the Coach Roméo app" },
            { fr: "Accès direct au coach sur WhatsApp", en: "Direct access to the coach on WhatsApp" },
            { fr: "Ajustements réguliers selon ta progression", en: "Regular adjustments based on your progress" },
        ],
        popular: true,
    },
    {
        id: "nutrition",
        name: { fr: "Nutrition", en: "Nutrition" },
        price: "300 $",
        period: { fr: "/2 mois", en: "/2 months" },
        tagline: {
            fr: "Plan alimentaire de 2 mois, bâti sur tes réalités, ton quotidien et ta culture — résultat garanti.",
            en: "2-month meal plan built on your realities, your daily life and your culture — results guaranteed.",
        },
        features: [
            { fr: "Plan nutrition complet sur 2 mois", en: "Complete 2-month nutrition plan" },
            { fr: "Construit autour de la cuisine africaine", en: "Built around African cuisine" },
            { fr: "Recettes recalibrées pour la perte de gras", en: "Recipes recalibrated for fat loss" },
            { fr: "Résultat garanti", en: "Results guaranteed" },
        ],
        popular: false,
    },
];

export const PACKS = [
    { id: "seance", name: { fr: "Séance ponctuelle", en: "Single session" }, price: "40 $", note: { fr: "1 séance à la salle", en: "1 gym session" } },
    { id: "deux-semaines", name: { fr: "Forfait 2 semaines", en: "2-week package" }, price: "200 $", note: { fr: "Séances à la salle", en: "Gym sessions" } },
    { id: "mois", name: { fr: "Forfait mensuel", en: "Monthly package" }, price: "400 $", note: { fr: "par mois · séances à la salle", en: "per month · gym sessions" } },
    { id: "trois-mois", name: { fr: "Forfait 3 mois", en: "3-month package" }, price: "1000 $", note: { fr: "Paiement unique", en: "One-time payment" } },
];

export const TIKTOK = { handle: "@romeofitness0", url: "https://www.tiktok.com/@romeofitness0" };

export const TESTIMONIALS = [
    {
        name: "Estalin Segura",
        location: "Gatineau",
        result: { fr: "Prise de masse musculaire en 18 mois", en: "Muscle mass gain in 18 months" },
        quote: {
            fr: "J'étais un athlète de base, je faisais du football américain, mais je n'avais aucune idée de la muscu fonctionnelle. Je voulais un préparateur physique, mais Roméo a plus que rempli mes attentes — je le recommande vivement.",
            en: "I was a basic athlete playing football, but I knew nothing about functional weight training. I wanted a strength coach, but Roméo more than exceeded my expectations — I highly recommend him.",
        },
        photo: "/images/clients/client-1.jpg",
    },
    {
        name: "Pretty Mary",
        result: { fr: "De 63 kg à 71 kg — 20 % de gras aujourd'hui", en: "From 63 kg to 71 kg — 20% body fat today" },
        quote: {
            fr: "J'ai connu le monde de la muscu grâce à Roméo. 3 ans que je m'entraîne et chaque entraînement, c'est comme si c'était le premier. Ma masse musculaire a augmenté — et mon fessier, n'en parlons pas. Les girls, subscribeeee !",
            en: "I discovered the world of weight training thanks to Roméo. 3 years of training and every workout feels like the first. My muscle mass has grown — and my glutes, don't get me started. Girls, subscribeeee!",
        },
        photo: "/images/clients/client-4.jpg",
    },
    {
        name: "Jean Derick M.",
        result: { fr: "De 29 % à 15 % de gras, masse maigre intacte", en: "From 29% to 15% body fat, lean mass intact" },
        quote: {
            fr: "Perdre du gras sans perdre 1 % de ma masse maigre, c'était un challenge. Roméo, merci pour tout — la diète, c'est un vrai régal. J'espère que tu ne me lâcheras pas. Merci pour la motivation constante.",
            en: "Losing fat without losing 1% of my lean mass was a challenge. Roméo, thank you for everything — the diet is a real treat. I hope you won't let go of me. Thanks for the constant motivation.",
        },
        photo: "/images/clients/client-3.jpg",
    },
    {
        name: "Julie D.",
        result: { fr: "Une façon de manger transformée", en: "A transformed way of eating" },
        quote: {
            fr: "Manger africain, c'est toujours le fun, mais savoir comment bien manger, c'est encore mieux. Les programmes alimentaires du coach Roméo sont de vraies pépites — il est ouvert aux modifications, toujours à l'écoute.",
            en: "Eating African is always fun, but knowing how to eat well is even better. Coach Roméo's meal programs are real gems — he's open to adjustments, always listening.",
        },
        photo: "/images/clients/client-6.jpg",
    },
];

export const FAQ_ITEMS = [
    {
        q: { fr: "Dois-je abandonner mes plats africains préférés pour perdre du gras ?", en: "Do I have to give up my favourite African dishes to lose fat?" },
        a: {
            fr: "Absolument pas. C'est toute ma philosophie : le mafé, le thiéboudienne, le ndolé ou le kedjenou peuvent tous être recalibrés — portions, techniques de cuisson, équilibre des assiettes — sans perdre leur âme. Tu manges ta culture, tu brûles du gras.",
            en: "Absolutely not. That's my whole philosophy: mafé, thiéboudienne, ndolé or kedjenou can all be recalibrated — portions, cooking techniques, plate balance — without losing their soul. You eat your culture, you burn fat.",
        },
    },
    {
        q: { fr: "Comment se déroule le coaching à distance ?", en: "How does online coaching work?" },
        a: {
            fr: "Tout se fait en ligne : appels Zoom de suivi, plans d'entraînement et de nutrition envoyés chaque semaine, et communication directe sur WhatsApp. Où que tu sois au Canada ou ailleurs, le suivi est le même qu'en personne.",
            en: "Everything happens online: Zoom follow-up calls, training and nutrition plans sent every week, and direct communication on WhatsApp. Wherever you are in Canada or elsewhere, the follow-up is the same as in person.",
        },
    },
    {
        q: { fr: "En combien de temps verrai-je des résultats ?", en: "How soon will I see results?" },
        a: {
            fr: "Les premiers changements visibles arrivent généralement entre la 4e et la 6e semaine : énergie, tour de taille, force. Les transformations majeures de mes clients se construisent sur 4 à 12 mois — durablement, sans effet yo-yo.",
            en: "The first visible changes usually come between weeks 4 and 6: energy, waistline, strength. My clients' major transformations are built over 4 to 12 months — sustainably, no yo-yo effect.",
        },
    },
    {
        q: { fr: "Combien coûte la consultation initiale ?", en: "How much is the initial consultation?" },
        a: {
            fr: "25 $ pour 30 minutes en visioconférence Zoom. On parle de tes objectifs, de ton historique et de ta relation avec la nourriture. À la fin, tu sais exactement quel programme te convient — sans aucune obligation.",
            en: "$25 for 30 minutes on Zoom. We talk about your goals, your history and your relationship with food. By the end, you know exactly which program fits you — with no obligation.",
        },
    },
    {
        q: { fr: "L'Ebook convient-il aux débutants en cuisine ?", en: "Is the Ebook suitable for cooking beginners?" },
        a: {
            fr: "Oui. Chaque recette est détaillée étape par étape, avec les temps de cuisson, les portions et les alternatives si un ingrédient est difficile à trouver. Les listes d'épicerie hebdomadaires te font gagner un temps fou.",
            en: "Yes. Each recipe is detailed step by step, with cooking times, portions and alternatives if an ingredient is hard to find. The weekly grocery lists save you a ton of time.",
        },
    },
    {
        q: { fr: "Faut-il un accès à une salle de sport ?", en: "Do I need a gym membership?" },
        a: {
            fr: "Non. Je construis ton plan selon ta réalité : salle complète, quelques haltères à la maison, ou poids du corps uniquement. La régularité compte plus que l'équipement.",
            en: "No. I build your plan around your reality: full gym, a few dumbbells at home, or bodyweight only. Consistency matters more than equipment.",
        },
    },
    {
        q: { fr: "Les plans conviennent-ils aux végétariens ?", en: "Do the plans work for vegetarians?" },
        a: {
            fr: "Oui. La cuisine africaine est riche en plats végétariens — feuilles, légumineuses, mil, fonio. J'adapte entièrement ton plan nutrition à ton mode d'alimentation.",
            en: "Yes. African cuisine is rich in vegetarian dishes — leaves, legumes, millet, fonio. I fully adapt your nutrition plan to your way of eating.",
        },
    },
    {
        q: { fr: "Comment fonctionnent les paiements et les forfaits ?", en: "How do payments and packages work?" },
        a: {
            fr: "Chaque formule est un forfait clair, sans frais cachés : musculation en présentiel à 400 $ (salles de gym à Gatineau et Ottawa), coaching en ligne 100 % personnalisé à 150 $ via l'application Coach Roméo, et plan nutrition de 2 mois à 300 $ avec résultat garanti. Les paiements se font par virement Interac uniquement, à l'adresse coachromeo7@hotmail.com.",
            en: "Each plan is a clear package with no hidden fees: in-person training at $400 (gyms in Gatineau and Ottawa), 100% personalized online coaching at $150 via the Coach Roméo app, and a 2-month nutrition plan at $300 with guaranteed results. Payments are made by Interac e-transfer only, to coachromeo7@hotmail.com.",
        },
    },
];
